//页面切换等状态管理
import * as types from '../types'


function get_cookie(Name) {
  var search = Name + "="//查询检索的值
  var returnvalue = "";//返回值
  if (document.cookie.length > 0) {
    let sd = document.cookie.indexOf(search);
    if (sd!= -1) {
      sd += search.length;
      let end = document.cookie.indexOf(";", sd);
      if (end == -1)
        end = document.cookie.length;
      //unescape() 函数可对通过 escape() 编码的字符串进行解码。
      returnvalue=unescape(document.cookie.substring(sd, end))
    }
  }
  return returnvalue;
}

if(localStorage.getItem('token')) {
  for (let key in localStorage) {
    document.cookie = key+'='+localStorage.getItem(key);
  }
}


const state = {
  token: get_cookie('token'),
  system_id: get_cookie('system_id'),
  id: get_cookie('id'),
};

const getters = {}
const actions = {}

const mutations = {
  [types.USER_TOKEN](state,payload) {
    state.token = payload.token
  },
  [types.SYSTEM_ID](state,payload) {
    state.system_id = payload.system_id
  },
  [types.ID](state,payload) {
    state.id = payload.id
  },
};

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/module/userModule.js